import { ReactNode } from "react";

import { ThreeDots } from "react-loader-spinner";

import { useMe } from "../../hooks/queries/use-me";

/**
 * Gates admin-only pages on `users.is_admin` (MDRS-102). Renders inside the
 * already-authenticated Layout, so it only decides admin vs not — a
 * non-admin sees a plain "no access" message rather than a redirect loop.
 */
function AdminRoute({ children }: { children: ReactNode }) {
  const { data, isLoading } = useMe();
  const isAdmin = data?.user?.is_admin ?? false;

  if (isLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <ThreeDots />
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <p className="text-foreground/70">You do not have access to this page.</p>
      </div>
    );
  }

  return <>{children}</>;
}

export default AdminRoute;
